// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1gy82","right":"styles_right__2agIT"};